import type { GameEventName, GameEvents } from "./GameEvents";

type Listener<K extends GameEventName> = (payload: GameEvents[K]) => void;

export class EventBus {
  private readonly listeners = new Map<GameEventName, Set<Listener<GameEventName>>>();

  on<K extends GameEventName>(event: K, listener: Listener<K>): () => void {
    let set = this.listeners.get(event);
    if (!set) {
      set = new Set();
      this.listeners.set(event, set);
    }
    set.add(listener as Listener<GameEventName>);
    return () => set!.delete(listener as Listener<GameEventName>);
  }

  emit<K extends GameEventName>(event: K, payload: GameEvents[K]): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const listener of set) listener(payload);
  }
}
